/**
 * AI 解析結果のユーザー検証 (AI Verification) 関連の型定義
 * (docs/04 §4-3, REQ-4.3.20〜25)。
 *
 * 既存の AI 解析パイプライン (Post.aiAnalysis) には触れず、
 * 独立したサブコレクション + Post への optional フィールドのみで
 * 検証 UI を成立させるための型一式。
 *
 * Firestore 構造:
 *   districts/{districtId}/aiVerificationTemplates/{templateId}        — 質問テンプレ
 *   districts/{districtId}/aiVerificationAssignmentSets/{setId}        — 配分セット
 *   districts/{districtId}/posts/{postId}/verifications/{participantUid} — 回答
 *   districts/{districtId}/posts/{postId}                              — verificationSummary を逆正規化
 *
 * 旧 `old/packages/shared-types/src/verification.ts` を admin 第 23 弾 (Phase 5 L2) で v2 に踏襲。
 * 旧との差分:
 *   - export path を `domain/verification.ts` に統合 (旧は top-level)
 *   - jsdoc を docs/04 §4-3 + REQ-4.3.20〜25 参照に更新
 *   - helpers (`isQuestionApplicable` / `ranksForQuestion` / `createDefault*`) は pure 関数のまま
 *   - schema 本体に変更なし (forward-compatible)
 */
/** runs のキー: 地区全体の実行。 */
export const ASSIGNMENT_PLAN_DISTRICT_KEY = '__district__';
// ============================================================
// ヘルパー
// ============================================================
/** 質問が AI 出力構造に対して有効か（モード差吸収） */
export function isQuestionApplicable(q, modeResult) {
    if (!q.enabled)
        return false;
    if (!q.fallbackHiddenIfMissing)
        return true;
    if (!q.targetField)
        return true; // フィールド指定なしは常に表示
    if (!modeResult)
        return false;
    return q.targetField in modeResult;
}
/** 適用 rank の判定 */
export function ranksForQuestion(q, totalRanks) {
    const target = q.appliesToRanks ?? 'top';
    if (target === 'all')
        return Array.from({ length: totalRanks }, (_, i) => i + 1);
    if (target === 'top')
        return totalRanks > 0 ? [1] : [];
    if (target === 'top3')
        return Array.from({ length: Math.min(3, totalRanks) }, (_, i) => i + 1);
    return target.filter((r) => r >= 1 && r <= totalRanks);
}
/** デフォルト質問の生成（テンプレート編集 UI で「+ 追加」時に使用）*/
export function createDefaultPerPostQuestion() {
    return {
        id: `q-post-${Date.now()}`,
        enabled: true,
        targetField: null,
        label: '',
        type: 'three_state',
        required: false,
    };
}
export function createDefaultPerClassificationQuestion() {
    return {
        id: `q-cls-${Date.now()}`,
        enabled: true,
        targetField: 'category',
        label: '',
        type: 'three_state',
        required: false,
        appliesToRanks: 'top',
        fallbackHiddenIfMissing: true,
    };
}
export function createDefaultRandomConstraints() {
    return {
        minPostsPerUser: 5,
        minOwnPosts: 0,
        allowDuplicates: false,
        preferOwnPosts: true,
        preferLessVerified: false,
    };
}
//# sourceMappingURL=verification.js.map